import React from "react";
import { Box, Typography } from "@mui/material";
import { headerAccentGradient } from "../../theme/theme";

// Consistent page header used at the top of every view: title, subtitle, a
// gradient accent bar, and an optional actions slot on the right.
export const PageHeader = ({ title, subtitle, darkMode, actions }) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 4, flexWrap: 'wrap', gap: 2 }}>
    <Box>
      <Box sx={{ width: 44, height: 4, borderRadius: 2, background: headerAccentGradient, mb: 1.5 }} />
      <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5, color: darkMode ? '#EAF3FB' : '#0E1B2C' }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" sx={{ color: darkMode ? '#93A2BC' : 'text.secondary' }}>
          {subtitle}
        </Typography>
      )}
    </Box>
    {actions && (
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
        {actions}
      </Box>
    )}
  </Box>
);

export default PageHeader;
